import { useEffect } from 'react';
import { isBrowser } from 'utils';

const events = ['keydown', 'mousemove', 'wheel', 'touchmove', 'touchstart', 'touchend'];

const AUTO_LOAD_DURATION = 8000;

export const useWaitForUser = (callback: () => void) => {
  useEffect(() => {
    if (!isBrowser()) return;

    const autoLoadTimeout = setTimeout(callback, AUTO_LOAD_DURATION);

    const triggerPreload = () => {
      callback();
      clearTimeout(autoLoadTimeout);
      events.forEach(event => window.removeEventListener(event, triggerPreload));
    };

    events.forEach(event =>
      window.addEventListener(event, triggerPreload, { passive: true, once: true })
    );
    return () => {
      events.forEach(event => window.removeEventListener(event, triggerPreload));
    };
  }, [callback]);
};
